<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path
        :stroke="color"
        d="M9.77 12.5l-4.19 4.869c-.56.131-.747.047-.888-.071L4.5 12.5H1.994c-.409 0-.765-.185-1.026-.457-.29-.3-.468-.71-.468-1.119V1.865c0-.371.171-.705.44-.948C1.228.657 1.627.5 2.066.5h13.868c.42 0 .797.193 1.076.473.297.298.49.7.49 1.103v9.059c0 .372-.171.705-.44.948-.288.26-.687.417-1.126.417H9.77z"
      />
      <circle cx="5" cy="7" r="1" :fill="color" />
      <circle cx="9" cy="7" r="1" :fill="color" />
      <circle cx="13" cy="7" r="1" :fill="color" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
